import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";
import { choose_template } from "./choose_template";

export function compose_document(bound_entity) {
    choose_template(bound_entity, "letter").done(function (template) {
        let newmessage_resource = HalResource(bound_entity).follow("uly:media").follow("uly:newdocument", {
            "template": template
        });
        newmessage_resource.then((result) => {
            console.log("compose_document");
            uly.dialogs.execute(
                result.dialog_markup, {
                "title": _("communications_title_create_document", "Create Document"),
                "buttons": {
                    "cancel": {
                        "caption": _("modal_caption_cancel", "Cancel"),
                        "button_class": "pull-left btn",
                        "icon": "fa fa-times-circle",
                        "action": "closedialog"
                    },
                    "ok": {
                        "caption": "Ok",
                        "button_class": "btn btn-primary",
                        "icon": "fa fa-check-circle",
                        "action": "closedialog"
                    },
                    "preview": {
                        "caption": "Preview",
                        "button_class": "btn btn-success",
                        "icon": "fa fa-eye",
                        "action": "previewdocument"
                    },
                }
            },
                $.extend({
                    "title": null,
                    "document": null
                }, result.message_data)
            )
                .then(function ([result]) {
                    newmessage_resource
                        .post(null, ko.toJS(result))
                        .always(uly.utils.show_results)
                        .then(function () {
                            //posted...
                            uly.publish("entity.modified", bound_entity);
                        });
                });
        }, function () {
            uly.utils.show_results({
                "success": false,
                "error": _("communications_error_generating_document", "There was an error generating the document. Please choose a template that does not cause an error.")
            });
        });
    });
}

export function edit_document(bound_entity) {
    HalResource(bound_entity).then(function (entity) {
        var res = HalResource(entity);
        return res.follow("uly:editdocument").then(function (result) {
            result.message_data.title = result.message_data.subject;
            uly.dialogs.execute(result.dialog_markup, {
                buttons: [{
                    "button": "cancel",
                    "caption": _("communications_caption_back", "Back"),
                    "button_class": "btn",
                    "icon": "fa fa-times-circle",
                    "action": "closedialog"
                }]
            }, result.message_data);
        });
    });
};

export function send_document_by_email(bound_entity) {
    console.log("composing message from document:", arguments);
    let newmessage_resource = HalResource(bound_entity).follow("uly:sendemail", {
        "document_id": bound_entity.unique_id
    });
    newmessage_resource.then(function (result) {
        console.log("Result :", result);
        uly.dialogs.execute(result.dialog_markup, {
            "title": _("communications_title_compose_message", "Compose Message")
        }, $.extend({
            "recipient": null,
            "title": null,
            "document": null,
            "cc": null,
            "bcc": null
        }, result.message_data))
            .done(function ([result]) {
                newmessage_resource.post(null, ko.toJS(result)).always(uly.utils.show_results).done(function (result) {
                    //posted...
                    uly.publish("entity.modified", bound_entity);
                });
            });
    });
};

